const batchType = require('../../batchType');
const batchStatus = require('../../batchStatus');

const bat = {
  BATCH_HAS_NO_TRANSFERS: {
    message: 'Your batch has no transfers, register transfers to close it.'
  },
  BANK_ACCOUNT_NOT_FILLED_YET: {
    message: 'You havent informed your bank account data yet, please access our web app to fill it'
  },
  INVALID_BATCH_TYPE: {
    message: `The batch type must be "${batchType.TRANSFER}" or "${batchType.BILLET}"`
  },
  INVALID_BATCH_NAME: {
    message: 'Invalid batch name'
  },
  INVALID_BATCH_UPDATE: {
    message: `The current batch status does not allow updates. Changes are only allowed in batches with the status ${batchStatus.DRAFT} or ${batchStatus.FINISHED}, in this case, only the reconciled field`
  }
};

module.exports = bat;
